import customAxios from 'services/customAxios'

const urls = {
  adminBillings: 'billings-v2',
  adminUsersTasks: 'billings-v2/users/:userId/tasks',

  adminBillingDetails: 'billings-v2/:billingId',

  adminBillingDelete: 'billings-v2/:billingId',
  adminBillingExport: 'billings-v2/:billingId/export',
  adminBillingExportFiltered: 'billings-v2/export/all',
  adminBillingExportBulk: 'billings-v2/export/bulk',
  adminConfirmBillingStatus: 'billings-v2/:billingId/status',

  userBillings: 'billings-v2/my-billings',
  userBillingDetails: 'billings-v2/my-billings/:billingId',
}

const adminGetBillings = (params) =>
  customAxios({
    method: 'get',
    url: urls.adminBillings,
    params,
  })

const adminGetBillingDetails = (billingId) =>
  customAxios({
    method: 'get',
    url: urls.adminBillingDetails.replace(':billingId', billingId),
  })

const adminGetUserAvailableTasks = (userId) =>
  customAxios({
    method: 'get',
    url: urls.adminUsersTasks.replace(':userId', userId),
  })

const adminCreateBilling = (data) =>
  customAxios({
    method: 'post',
    url: urls.adminBillings,
    data,
  })

const adminConfirmBillingStatus = (billingId) =>
  customAxios({
    method: 'put',
    url: urls.adminConfirmBillingStatus.replace(':billingId', billingId),
  })

const adminExportBilling = (billingId) =>
  customAxios({
    method: 'get',
    url: urls.adminBillingExport.replace(':billingId', billingId),
    responseType: 'blob',
  })

const adminExportFilteredBilling = (params) =>
  customAxios({
    method: 'get',
    url: urls.adminBillingExportFiltered,
    params,
    responseType: 'blob',
  })

const adminExportBulkBilling = (billingIds) =>
  customAxios({
    method: 'post',
    url: urls.adminBillingExportBulk,
    data: { billingIds },
    responseType: 'blob',
  })

const adminDeleteBilling = (billingId) =>
  customAxios({
    method: 'delete',
    url: urls.adminBillingDelete.replace(':billingId', billingId),
  })

// Users
const userGetBillings = (params) =>
  customAxios({
    method: 'get',
    url: urls.userBillings,
    params,
  })

const userGetBillingDetails = (billingId) =>
  customAxios({
    method: 'get',
    url: urls.userBillingDetails.replace(':billingId', billingId),
  })

export const billingsService = {
  adminGetBillings,
  adminGetBillingDetails,
  adminGetUserAvailableTasks,
  adminCreateBilling,
  adminConfirmBillingStatus,
  adminExportBilling,
  adminExportFilteredBilling,
  adminExportBulkBilling,
  adminDeleteBilling,
  userGetBillings,
  userGetBillingDetails,
}
